import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { OrderLog } from 'types/embedded/orderLog';

type Props = Omit<FunctionFieldProps, 'render' | 'source'>;

export const OrdersShowLogsTypeField: React.FC<Props> = (props) => {
  const translate = useTypedTranslate();

  return (
    <FunctionField
      render={(record: OrderLog) => (
        <Stack alignItems="center" direction="row" gap="8px">
          <Typography color="secondary" sx={{ lineHeight: 1 }} variant="body2">
            {translate('app.orders.logs.requestType')}
          </Typography>
          <Typography variant="body2">{record?.actionType}</Typography>
        </Stack>
      )}
      sortable={false}
      {...props}
    />
  );
};
